import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';

@Injectable()
export class LSAppService {

    public user = null;
    
    constructor() {
        
     }

     private titleCase(str) {
        var splitStr = str.toLowerCase().split(' ');
        for (var i = 0; i < splitStr.length; i++) {
            // You do not need to check if i is larger than splitStr length, as your for does that for you
            // Assign it back to the array
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
        }
        // Directly return the joined string
        return splitStr.join(' '); 
     }

    getCurrentAuthToken() {
        if(this.isUserLoggedIn()) {
            return this.user.authToken;
        }
        else {
            return "[invalid_token]";
        }
    }
     
    isUserLoggedIn() {
        //this.user = {firstname:"Nirav", lastname:"Shah"};
        //if(this.user == null) {
            if(localStorage.getItem("user") == null) {
                return false;
            }
            else {

                try {
                    this.user = JSON.parse(localStorage.getItem("user"));
                }
                catch(ex) { 
                    console.log(ex);
                    this.user = null;
                    return false;
                }
                return true;

            }
        //}
        //else {
            //return true;
        //}
    }



}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/services/LSApp.service.ts